export function formatDateOrder(iso: string): string {
  const date = new Date(iso);

  if (isNaN(date.getTime())) {
    throw new Error('Invalid ISO date string');
  }

  const pad = (n: number): string => n.toString().padStart(2, '0');

  const day = pad(date.getUTCDate());
  const month = pad(date.getUTCMonth() + 1);
  const year = date.getUTCFullYear();

  const hours = pad(date.getUTCHours());
  const minutes = pad(date.getUTCMinutes());

  return `${day}.${month}.${year} ${hours}:${minutes}`;
}
